import React from 'react';

export const HomeCover = ({ isLoggedIn, currentUser, onNavigate, onLogout, onShowLogin, onShowTrialRegister }) => (
  <div className="min-h-screen bg-gradient-to-br from-blue-900 via-indigo-900 to-purple-900 flex items-center justify-center relative overflow-hidden">
    {/* Background Pattern */}
    <div className="absolute inset-0 bg-black bg-opacity-20"></div>
    <div className="absolute inset-0" style={{
      backgroundImage: 'radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(255,255,255,0.1) 0%, transparent 50%)'
    }}></div>

    <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6">
      {/* Logo Principal */}
      <div className="mb-8">
        <div className="w-32 h-32 mx-auto mb-6 bg-white rounded-full p-4 shadow-2xl flex items-center justify-center">
          <div className="text-6xl">📖</div>
        </div>

        <h1 className="text-6xl font-bold mb-4 tracking-wider">
          App EBD
        </h1>

        <div className="text-xl text-blue-200 mb-6">
          <p className="font-semibold text-white">Sistema de Gerenciamento</p>
          <p className="text-lg">Escola Bíblica Dominical</p>
        </div>
      </div>

      {/* Recursos do Sistema */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 border border-white border-opacity-20">
          <div className="text-3xl mb-3">✅</div>
          <h3 className="font-semibold mb-2">Chamada Digital</h3>
          <p className="text-sm text-blue-200">Controle de presença rápido e eficiente</p>
        </div>

        <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 border border-white border-opacity-20">
          <div className="text-3xl mb-3">📊</div>
          <h3 className="font-semibold mb-2">Relatórios</h3>
          <p className="text-sm text-blue-200">Classes vencedoras e estatísticas completas</p>
        </div>

        <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 border border-white border-opacity-20">
          <div className="text-3xl mb-3">👥</div>
          <h3 className="font-semibold mb-2">Gestão de Alunos</h3>
          <p className="text-sm text-blue-200">Cadastro e transferência entre turmas</p>
        </div>

        <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 border border-white border-opacity-20">
          <div className="text-3xl mb-3">💰</div>
          <h3 className="font-semibold mb-2">Controle de Ofertas</h3>
          <p className="text-sm text-blue-200">Registro de ofertas e materiais distribuídos</p>
        </div>
      </div>

      {/* Botão de Entrada */}
      <div className="space-y-4">
        {isLoggedIn ? (
          <div className="space-y-3">
            <button
              onClick={() => onNavigate('dashboard')}
              className="px-12 py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 text-gray-900 rounded-full text-xl font-bold hover:from-yellow-400 hover:to-yellow-500 transform hover:scale-105 transition-all duration-300 shadow-2xl"
            >
              🚀 Acessar Sistema
            </button>

            <div className="flex items-center justify-center space-x-4 text-blue-200">
              <span>Logado como: <strong>{currentUser?.nome}</strong></span>
              <button
                onClick={onLogout}
                className="text-yellow-400 hover:text-yellow-300 underline"
              >
                Sair
              </button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={onShowLogin}
              className="px-10 py-4 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-full text-xl font-bold hover:from-indigo-400 hover:to-blue-500 transform hover:scale-105 transition-all duration-300 shadow-2xl"
            >
              Fazer Login
            </button>
            <button
              onClick={onShowTrialRegister}
              className="px-10 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-full text-xl font-bold hover:from-green-400 hover:to-emerald-500 transform hover:scale-105 transition-all duration-300 shadow-2xl"
            >
              Criar Conta
            </button>
          </div>
        )}

        <p className="text-blue-300 text-sm mt-4">
          Sistema desenvolvido por Márcio Ferreira
        </p>
      </div>
    </div>
  </div>
);
